import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "icon_table_video_on",
  xmlns: "http://www.w3.org/2000/svg",
  width: "26.001",
  height: "15",
  viewBox: "0 0 26.001 15"
}
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      id: "Path_309",
      "data-name": "Path 309",
      d: "M-4111.921,459H-4125a3,3,0,0,1-3-3v-9a3,3,0,0,1,3-3h13.077a3,3,0,0,1,3,3v2.281l5.035-2.585a2.394,2.394,0,0,1,.879-.2c.642,0,1.01.417,1.01,1.145v8.416a1.047,1.047,0,0,1-1.108,1.147h-.006a1.983,1.983,0,0,1-.774-.174l-5.035-2.584V456A3,3,0,0,1-4111.921,459Zm-9.294-12.68a1,1,0,0,0-1,1v7.728a1,1,0,0,0,1,1,1,1,0,0,0,.531-.155l6.125-3.864a1,1,0,0,0,.467-.847.994.994,0,0,0-.467-.845l-6.125-3.864A1,1,0,0,0-4121.215,446.321Z",
      transform: "translate(4128 -444.001)",
      fill: _ctx.isOn ? 'white' : 'red'
    }, null, 8, _hoisted_2)
  ]))
}